module.exports = __webpack_public_path__ + "static/img/wechat-qrcode.8a372a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat-qrcode.jpg
// module id = 401
// module chunks = 40